import { useEffect, useState } from 'react';
import { API_ROOT, sendRequest } from '../../../../supplementary_components/requests';

const previews = new Map();

function ensurePreview(truckId) {
    let entry = previews.get(truckId);
    if (entry && entry.status !== 'error') return entry;
    if (!entry) {
        entry = { status: 'loading', rows: [], listeners: new Set() };
        previews.set(truckId, entry);
    } else {
        entry.status = 'loading';
        entry.rows = [];
    }
    sendRequest(
        'GET',
        `${API_ROOT}invoices/by-truck/${truckId}`,
        null,
        (data) => {
            if (!Array.isArray(data)) {
                entry.status = 'error';
                entry.rows = [];
            } else {
                entry.status = 'ready';
                entry.rows = data;
            }
            entry.listeners.forEach((listener) => listener());
        },
        () => {
            entry.status = 'error';
            entry.rows = [];
            entry.listeners.forEach((listener) => listener());
        },
    );
    return entry;
}

/** Latest five invoices for the truck-page preview. Shared by the list and the View All button. */
export function useTruckInvoicePreview(truckId) {
    const [state, setState] = useState({ status: 'loading', rows: [] });

    useEffect(() => {
        if (truckId == null) return undefined;
        const entry = ensurePreview(truckId);
        const sync = () => setState({ status: entry.status, rows: entry.rows });
        sync();
        entry.listeners.add(sync);
        return () => entry.listeners.delete(sync);
    }, [truckId]);

    return state;
}
